import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/useRedux";
import { logoutUser } from "../store/userSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import LOGO from "../assets/images/newLogo.png";
import APPNAME from "../assets/images/appname.png";
import { BASE_URL } from "../Constants/BaseUrl";

const Logout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const user = useAppSelector((state) => state.user);

  const handleLogout = async () => {
    setLoading(true);

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${BASE_URL}auth/logout`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    };

    try {
      const response = await axios.request(config);
      console.log(response.data, "TestingLogout");
      dispatch(logoutUser());
      toast.success("Logged out successfully");
      navigate("/login");
    } catch (error) {
      // @ts-ignore
      toast.error(error?.response?.data?.error || "Something went wrong");
      // @ts-ignore
      console.log("Logout error:", error?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#121212] text-white px-4 py-8 flex items-center justify-center">
      <ToastContainer />
      <div className="max-w-xl mx-auto text-center">
        <img
          src={LOGO}
          alt="logo"
          className="h-40 w-40 object-contain mx-auto mb-4"
        />
        <img
          src={APPNAME}
          alt="app name"
          className="h-14 object-contain mx-auto mb-6"
        />
        <h2 className="text-2xl font-semibold uppercase text-white mb-4">
          LOG OUT
        </h2>
        <p className="text-sm text-gray-300 mb-6">
          Are you sure you want to log out?
        </p>
        <div className="space-y-4">
          <button
            onClick={handleLogout}
            disabled={loading}
            className="w-full max-w-md bg-[#C00000] hover:bg-red-700 text-white py-3 rounded-md font-semibold transition"
          >
            {loading ? "Logging out..." : "YES, LOG OUT"}
          </button>
          <button
            onClick={() => navigate(-1)}
            disabled={loading}
            className="w-full max-w-md bg-[#333333] hover:bg-gray-600 text-white py-3 rounded-md font-semibold transition"
          >
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};

export default Logout;
